import request from '@/utils/request'

import { ResponseData, ResponseDataList, Search, CURD } from '../schemas'



export const getList = (data: Search): Promise<ResponseDataList> => {
  return request({
    url: '/cities/search',
    method: 'post',
    data,
  })
}


export const doAdd = (data: CURD): Promise<ResponseData> => {
  return request({
    url: '/cities',
    method: 'post',
    data,
  })
}

export const doUpdate = (data: CURD): Promise<ResponseData> => {
  return request({
    url: `/cities`,
    method: 'put',
    data,
  })
}


export const doDelete = (data: CURD): Promise<ResponseData> => {
  return request({
    url: `/cities/${String(data.id)}`,
    method: 'delete',
  })
}
